import { Component, type ReactNode } from 'react'

interface Props {
  children: ReactNode
  fallback?: ReactNode
}

interface State {
  hasError: boolean
  error?: Error
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? (
        <div className="flex min-h-[200px] items-center justify-center rounded-lg border border-destructive/50 bg-destructive/10 p-6 text-center">
          <div>
            <p className="font-semibold text-destructive">Something went wrong</p>
            {this.state.error && (
              <p className="mt-1 text-sm text-muted-foreground">{this.state.error.message}</p>
            )}
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
